import * as types from '../constants/actionTypes';

export function autoplayStop() {
  return {
    type: types.AUTOPLAY_STOP
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/autoplay.js
 **/